import { state, getters, actions, mutations } from './user.store.js';
export default {
	state,
	getters,
	actions,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js